/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import { getItem } from '@Utils/LocalStorage';
import { PROJECTS_STATE_LOCAL_STORAGE_KEY, PROJECTS_REDUCER_NAME } from './Constants';

const initialState = getItem(PROJECTS_STATE_LOCAL_STORAGE_KEY) || {
  projects: [],
};

export const projectsSlice = createSlice({
  name: PROJECTS_REDUCER_NAME,
  initialState,
  reducers: {
    setProjects: (state, { payload: { projects } }) => {
      state.projects = projects;
    },

    deleteProjectById: (state, { payload: { projectId } }) => {
      const targetProjectIndex = state.projects.findIndex(({ id }) => id === projectId);

      state.projects.splice(targetProjectIndex, 1);
    },
  },
});

const { setProjects, deleteProjectById } = projectsSlice.actions;

export { setProjects, deleteProjectById };

export default projectsSlice.reducer;
